// public/js/features/assets/assets-page.js
import { initAssetsListPage } from './list-view.js'; // if separate
import { renderAssetDetail } from './asset-detail-view.js';

let currentView = 'list';
let currentAssetUUID = null;

export async function initAssetsPage(container) {
  const hash = window.location.hash || '#assets';

  container.innerHTML = `
    <div id="assets-list-view"></div>
    <div id="assets-detail-view" class="d-none"></div>
  `;

  const listView = document.getElementById('assets-list-view');
  const detailView = document.getElementById('assets-detail-view');

  async function showListView(forceRefresh = false) {
    currentView = 'list';
    currentAssetUUID = null;
    detailView.classList.add('d-none');
    listView.classList.remove('d-none');

    // The list loads through the shared asset store (delta cache) — which is
    // tenant-scope-aware — instead of a page-local unscoped fetch.
    await initAssetsListPage(listView, null);
  }

  async function showAssetDetail(assetUUID) {
    currentView = 'detail';
    currentAssetUUID = assetUUID;
    listView.classList.add('d-none');
    detailView.classList.remove('d-none');

    const onBack = () => {
      history.pushState(null, '', '#assets');
      showListView(); // ← cache-first!
    };

    await renderAssetDetail(detailView, assetUUID, onBack);
  }

  if (hash.startsWith('#assets/') && hash.length > 8) {
    const assetUUID = hash.split('/')[1];
    await showAssetDetail(assetUUID);
  } else {
    await showListView();
  }

  const handleHashChange = () => {
    const newHash = window.location.hash || '#assets';
    if (newHash.startsWith('#assets/') && currentView !== 'detail') {
      const assetUUID = newHash.split('/')[1];
      showAssetDetail(assetUUID);
    } else if (!newHash.startsWith('#assets/') && currentView === 'detail') {
      showListView();
    }
  };

  window.addEventListener('hashchange', handleHashChange);
  window.showAssetDetail = showAssetDetail;
}